import React, {useMemo} from 'react';
import { AutocompleteOption } from '../../../SortFilter/interfaces';
import {Autocomplete, AutocompleteProps, TextField} from "@mui/material";
import { useAutocompleteOptions } from '../../../../hooks/autocomplete/useAutocompleteOptions';
import useAssetTypes from '../../../../hooks/components/location/useAssetTypes';

interface AssetTypeAutocompleteProps extends Omit<AutocompleteProps<any, any, any, any>, 'renderInput' | 'options'> {
}

const AssetTypeAutocomplete = (props: AssetTypeAutocompleteProps) => {
  const assetTypes = useAssetTypes();

  const assetTypeOptions = useMemo<Array<AutocompleteOption>>(() => {
    if (assetTypes?.length) {
      return assetTypes.map(assetType => ({ id: assetType.key, label: assetType.value }));
    }
    return [];
  }, [assetTypes]);

  const renderInput = (params: any) => (
    <TextField {...params} label={'Asset Type'} variant={'standard'} />
  )

  const {
    handleGetOptionLabel,
    handleIsOptionEqualToValue,
  } = useAutocompleteOptions({ autocompleteOptions: assetTypeOptions })

  return (
    assetTypeOptions?.length > 1 && <Autocomplete
      disablePortal
      disableClearable
      renderInput={renderInput}
      options={assetTypeOptions}
      getOptionLabel={handleGetOptionLabel}
      isOptionEqualToValue={handleIsOptionEqualToValue}
      {...props}
    />
  )
}

export { AssetTypeAutocomplete };
